import React from 'react';
import { Modal } from 'antd';
import { Banner } from '../../types/banner';
import { AssetModalHeader } from './asset-modal-header';
import { AssetInfoPanel } from './info-panel/asset-info-panel';
import { AssetMediaPanel } from './media-panel/asset-media-panel';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';
import { useBanners } from '../../context/banners';

interface AssetModalProps {
  clientId: string;
  banner: Banner;
  open: boolean;
  onClose: () => void;
}

export const AssetModal: React.FC<AssetModalProps> = ({ clientId, banner, open, onClose }) => {
  const { spacing, screens } = useResponsiveSizes();
  const { refreshAllBanners } = useBanners();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={screens.lg ? 900 : '90%'}
      centered
      style={{ borderRadius: 16 }}
      styles={{
        body: {
          padding: 0,
          background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
          maxHeight: '85vh',
          overflow: screens.md ? 'hidden' : 'auto',
          display: 'flex',
          flexDirection: 'column'
        },
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'blur(10px)'
        },
        content: {
          padding: 0,
          borderRadius: 20,
          overflow: 'hidden'
        }
      }}
      closeIcon={null}
    >
      {/* Header */}
      <AssetModalHeader banner={banner} onClose={onClose} />

      {/* Body - Grid Layout */}
      <div
        style={{
          padding: screens.xs
            ? `${spacing.sm}px ${spacing.md}px ${spacing.md}px ${spacing.md}px`
            : screens.lg
              ? `${spacing.sm}px ${spacing.xl}px ${spacing.md}px ${spacing.xl}px`
              : `${spacing.sm}px ${spacing.lg}px ${spacing.lg}px ${spacing.lg}px`,
          display: 'grid',
          gridTemplateColumns: screens.md ? '1fr 1fr' : '1fr',
          gap: spacing.xl,
          flex: screens.md ? 1 : 'none',
          backgroundColor: 'white',
          overflow: 'hidden',
          minHeight: screens.md ? 0 : 'auto'
        }}
      >
        {/* Panel de Información (izquierda) */}
        <div
          style={{
            overflow: 'hidden',
            height: '100%',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <AssetInfoPanel banner={banner} clientId={clientId} onDeleted={refreshAllBanners} onClose={onClose} />
        </div>

        {/* Panel Multimedia (derecha) */}
        <div
          style={{
            overflow: 'hidden',
            height: '100%',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            scrollbarColor: '#e3e3e3 #FFFFFF'
            //scrollbarWidth: 'thin'
          }}
        >
          <AssetMediaPanel banner={banner} />
        </div>
      </div>
    </Modal>
  );
};
